export enum typeToast {
  success = 1,
  warning = 2,
  error = 3,
  wait = 4,
  info = 5
}
